"use client";

import { FC } from "react";
import { Flex } from "@chakra-ui/react";
import TabLink from "./TabLink";

type Action = {
  isActive?: boolean;
  isDisabled?: boolean;
  label: string;
  onClick: VoidFunction;
};

export type Props = {
  actions: Action[];
};

const TabLinks: FC<Props> = ({ actions }) => (
  <Flex justify="flex-start" mb={8}>
    <Flex
      as="ul"
      gap={1}
      boxShadow="0 0 13px 0 #cbd5e0"
      pt={1}
      pb={1}
      paddingInlineStart={1}
      paddingInlineEnd={1}
      overflowX="auto"
      maxWidth="100%"
      borderRadius="40px"
      whiteSpace="nowrap"
      listStyle="none"
    >
      {actions.map(({ isActive, isDisabled, label, onClick }) => (
        <TabLink
          key={label}
          onClick={onClick}
          isActive={isActive}
          isDisabled={isDisabled}
        >
          {label}
        </TabLink>
      ))}
    </Flex>
  </Flex>
);

export default TabLinks;
